import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import {FcExpired} from 'react-icons/fc'
import BtnForms from '../UiComponents/forms/BtnForms';
import styles from './SessionDisconnect.module.scss'
import {BsFillArrowRightCircleFill} from 'react-icons/bs'
import logo from '../../pics/logo-hearingspace.png'
const SessionDisconnect = () => {

const { t } = useTranslation();
const navigate=useNavigate()


    return (

        <div className='fixed-container-modals'>
            <div className={styles.containerExpired}>
<img src={logo} alt="" />
<h1>{t("session.expired_title")}</h1>
<FcExpired style={{fontSize:'50px'}}/>
<BtnForms onClick={()=>navigate('/')} text={t("session.reconnect_button")} svg={<BsFillArrowRightCircleFill/>}/>




            </div>
        </div>
    );
};

export default SessionDisconnect;